import { useState } from "react";
import { Button, Card, CardContent, Typography, Box } from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { useDeleteQrTemplateMutation } from "../../../api/managementApi";
import { useToast } from "../../../components/ui/Toast";
import AddTemplateModal from "./AddTemplateModal";
import ShareInviteModal from "./ShareInviteModal";

export default function QrTemplateList({ groupId, groupName, templates }) {
  const { t } = useScriptMode();
  const toast = useToast();
  const [createOpen, setCreateOpen] = useState(false);
  // Düzenlenen şablon; null ise pencere yeni şablon için açılır.
  const [editTemplate, setEditTemplate] = useState(null);
  const [shareTemplate, setShareTemplate] = useState(null);
  const [deleteTemplate, { isLoading: deleteLoading }] = useDeleteQrTemplateMutation();

  const list = Array.isArray(templates) ? templates : [];

  const handleDelete = async (templateId) => {
    try {
      await deleteTemplate({ groupId, templateId }).unwrap();
      toast.success(t("manage_template_deleted"));
    } catch (err) {
      const msg = err?.message || err?.data?.message || t("manage_template_delete_error");
      toast.error(msg);
    }
  };

  return (
    <>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          variant="contained"
          onClick={() => {
            setEditTemplate(null);
            setCreateOpen(true);
          }}
        >
          {t("manage_add_template_cta")}
        </Button>
      </Box>

      {list.length === 0 ? (
        <Box textAlign="center" py={4}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {t("manage_template_empty_title")}
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1}>
            {t("manage_template_empty_body")}
          </Typography>
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" gap={2}>
          {list.map((tpl) => (
            <Card key={tpl.id} variant="outlined">
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between" gap={2}>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {tpl.groupName || groupName || String(tpl.id).slice(-8)}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {t("manage_template_goal_count").replace(
                        /\{count\}/g,
                        tpl.goalTemplates?.length ?? 0
                      )}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={1}>
                    <Button
                      size="small"
                      onClick={() => {
                        setEditTemplate(tpl);
                        setCreateOpen(true);
                      }}
                    >
                      {t("manage_template_edit_cta")}
                    </Button>
                    <Button size="small" onClick={() => setShareTemplate(tpl)}>
                      {t("manage_template_share_cta")}
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      onClick={() => handleDelete(tpl.id)}
                      disabled={deleteLoading}
                    >
                      {t("manage_template_delete_cta")}
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      )}

      <AddTemplateModal
        open={createOpen}
        groupId={groupId}
        template={editTemplate}
        onClose={() => setCreateOpen(false)}
        onCreated={() => toast.success(t(editTemplate ? "manage_template_updated" : "manage_template_created"))}
      />
      <ShareInviteModal
        open={!!shareTemplate}
        groupId={groupId}
        templateId={shareTemplate?.id}
        groupName={groupName}
        onClose={() => setShareTemplate(null)}
      />
    </>
  );
}
